import { render, staticRenderFns } from "./marques-stats.vue?vue&type=template&id=7d777c5a"
import script from "./marques-stats.vue?vue&type=script&lang=js"
export * from "./marques-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports